import { aanpAuthOptions } from "./util";
import { apiUrl } from "../config";
import instance from "./instance";

export function getRegistration() {
	return instance.get(`${apiUrl}/registration`, aanpAuthOptions()).then(r => r.data);
}

export function getAvailablePresenationsByDay(day) {
	return instance.get(`${apiUrl}/registration/getAvailablePresentations/${day}`, aanpAuthOptions()).then(r => r.data);	
}

export function savePendingPresentation(presentationId) {	
	return instance.post(`${apiUrl}/registration/savePendingPresentation`, presentationId, aanpAuthOptions()).then(r => r.data);	
}

export function removePendingPresentation(presentationId) {	
	return instance.post(`${apiUrl}/registration/removePendingPresentation`, presentationId, aanpAuthOptions()).then(r => r.data);	
}

export function getSchedule() {
	return instance.get(`${apiUrl}/registration/getSchedule`, aanpAuthOptions()).then(r => r.data);	
}

export function resolveScheduleConflict(presentationId) {	
	return instance.post(`${apiUrl}/registration/resolveScheduleConflict`, presentationId, aanpAuthOptions()).then(r => r.data);	
}

export function getRegistrationComplete() {
	return instance.get(`${apiUrl}/registration/getRegistrationComplete`, aanpAuthOptions()).then(r => r.data);	
}

export function removeDefaultSessions() {
	return instance.post(`${apiUrl}/registration/removeDefaultSessions`, {}, aanpAuthOptions()).then(r => r.data);	
}

export function removeFullPresentations() {
	return instance.post(`${apiUrl}/registration/removeFullPresentations`, {}, aanpAuthOptions()).then(r => r.data);	
}

export function removeUnprocessedPresentations() {
	return instance.post(`${apiUrl}/registration/removeUnprocessedPresentations`, {}, aanpAuthOptions()).then(r => r.data);	
}

export function getPresentations(presentationIds) {
	return instance.get(`${apiUrl}/registration/getPresentations/${presentationIds}`, aanpAuthOptions()).then(r => r.data);
}